import React, { FC, memo } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
    background-color: #fff;
    padding: 16px;
    display: flex;
    color: rgba(0, 0, 0, 0.85);
    border-radius: 2px;
    margin-top: 8;
    flex-direction: column;
`;

const TitleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    line-height: 22px;
    margin-bottom: 8px;
    padding: 0 0 8px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;

const Title = styled.div`
    font-weight: 500;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
`;

const Extra = styled.div``;

interface TemplateProps {
    title: string;
    loading?: boolean;
    fallback?: any;
    extra?: React.ReactNode;
}

export const Template: FC<TemplateProps> = memo((props) => {
    const { title, loading, fallback, extra } = props;

    return (
        <Wrapper>
            <TitleWrapper>
                <Title>{title}</Title>
                <Extra>{extra}</Extra>
            </TitleWrapper>

            {loading ? fallback : props.children}
        </Wrapper>
    );
});

export default Template;
